export default {
  ACCEPTED: 'ACCEPTED',
  REFUSED: 'REFUSED',
  WAITING_FOR_ACCEPTANCE: 'WAITING_FOR_ACCEPTANCE',
  COMPLETED: 'COMPLETED',
}

export const offerType = {
  ADVANTAGEOUS_PRICE: 'ADVANTAGEOUS_PRICE',
  SUPER_PRICE: 'SUPER_PRICE',
  SHOCKING_PRICE: 'SHOCKING_PRICE',
}

export const DEAL_TYPES = {
  NEW_DEAL: 'NEW_DEAL',
  DEAL: 'DEAL',
  BO_DELETED_DEAL: 'BO_DELETED_DEAL',
}

export const OFFER_STATUS = {
  ACCEPTED: 'ACCEPTED',
  REFUSED: 'REFUSED',
  WAITING_FOR_ACCEPTANCE: 'WAITING_FOR_ACCEPTANCE',
  COMPLETED: 'COMPLETED',
  WAITING_FOR_APPLYING: 'WAITING_FOR_APPLYING',
  DELETED_BY_BO_OPERATOR: 'DELETED_BY_BO_OPERATOR'
};

export const OFFER_PRICE_TYPES = {
  ADVANTAGEOUS_PRICE: 'ADVANTAGEOUS_PRICE',
  SUPER_PRICE: 'SUPER_PRICE',
  SHOCKING_PRICE: 'SHOCKING_PRICE',
};
